// @flow

export const REQUEST_TRANSLATOR_LOAD_LANGUAGES =
  'REQUEST_TRANSLATOR_LOAD_LANGUAGES'
export const REQUEST_TRANSLATE_LANGUAGES_WERE_LOADED =
  'REQUEST_TRANSLATE_LANGUAGES_WERE_LOADED'
export const REQUEST_TRANSLATE = 'REQUEST_TRANSLATE'
export const REQUEST_WAS_TRANSLATED = 'REQUEST_WAS_TRANSLATED'
export const REQUEST_TRANSLATIONS_RESET = 'REQUEST_TRANSLATIONS_RESET'
